import React, { Component } from "react";
import "./CertificationCard.css";
import { Fade } from "react-reveal";

class CertificationCard extends Component {
  render() {
    const certificate = this.props.certificate;
    const theme = this.props.theme;
    const isDark = this.props.isDark || false;

    // Use dark-mode-friendly logo variants for AWS
    let logoPath = certificate.logo_path;
    if (isDark && certificate.logo_path === "aws_transparent.png") {
      logoPath = "aws_dark.svg";
    }

    return (
      <Fade bottom duration={2000} distance="20px">
        <div
          className="cert-card"
          style={{
            backgroundColor: isDark ? "#1C1C1C" : "transparent",
            borderColor: isDark ? "#333333" : "#d9dbdf",
            boxShadow: isDark
              ? "0 4px 12px rgba(0,0,0,0.3)"
              : "0 4px 12px rgba(0,0,0,0.06)",
          }}
        >
          <div className="content">
            <a
              href={certificate.certificate_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="content-overlay"></div>
              <div
                className="cert-header"
                style={{
                  backgroundColor: isDark ? "#2A2A2A" : certificate.color_code,
                }}
              >
                <img
                  className="logo_img"
                  src={require(`../../assets/images/${logoPath}`)}
                  alt={certificate.alt_name}
                />
              </div>
              <div className="content-details fadeIn-top">
                <h3 className="content-title" style={{ color: theme.body }}>
                  Certificate
                </h3>
              </div>
            </a>
          </div>
          <div className="cert-body">
            <h2 className="cert-body-title" style={{ color: theme.text }}>
              {certificate.title}
            </h2>
            <h3
              className="cert-body-subtitle"
              style={{ color: theme.secondaryText }}
            >
              {certificate.subtitle}
            </h3>
          </div>
        </div>
      </Fade>
    );
  }
}

export default CertificationCard;
